module.exports = __webpack_public_path__ + "static/img/lifestyle_03.67edf8f7.jpg";